import { z } from "zod";
import type { Operation } from "../types";

export interface TreeProject {
  slug: string;
  name: string;
  source: "claude" | "manual";
  group_id: number | null;
  claude_path: string | null;
  pending: boolean;
}

export interface TreeGroup {
  id: number;
  slug: string;
  name: string;
}

export interface TreePayload {
  groups: TreeGroup[];
  projects: TreeProject[];
}

const getOp: Operation<void, void, void, TreePayload> = {
  method: "GET",
  path: () => "/projects/api/tree",
  response: z.custom<TreePayload>(),
};

export const projectsTree = {
  get: getOp,
};
